import { api } from './_request';

 export const get = (data) => {
 	return (dispatch) => {
				dispatch({
				type: 'LIST',
					payload: data
 				});
 	}
 };

export const save = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('movimientocac', item).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'SAVE_SUCCESS',
					payload: response.data.documento
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const update = (item, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'SAVE' });

		api().post(`movimientocac/${item.id}`, item)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data
				});
				console.log('movimientocac action----->', response.data);

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

	export const alerta = (alerta) => {
		return (dispatch) => {
			dispatch({
						type: 'SAVE_ALERTA',
						payload: alerta
					});
		}
	};
	export const peticion = () => {
		return (dispatch) => {
			dispatch({ type: 'SAVE' });
		}
	};
	export const actualizar_renglon = (renglon) => {
		return (dispatch) => {
			dispatch({
				type: 'UPDATE_SUCCESS',
				payload: renglon
			});
		}
	};

	export const enviar_correo = (correos, callback) => {
	
	return (dispatch) => {

		dispatch({ type: 'TICKET_SAVE' });
  		console.log('correos--->',correos);
		api().post('/movimientocac_correo', correos).then(function(response) {

			if(response.status === 200) {
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data.movimiento
			    });

				if(typeof callback === 'function')
					callback(response.data);
			}
			else {
				dispatch({ type: 'UPDATE_FAILURE' });
			}
		})
		.catch(function(error) {
			console.log('error-->',error);
			dispatch({ type: 'UPDATE_FAILURE' });
		});

	}
};


// WEBPACK FOOTER //
// ./src/actions/movimientocaclientes.js